var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"9","height":"9","rx":"4.5","fill":"white"}}),_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"9","height":"9","rx":"4.5","stroke":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }